import React from 'react';
import styled from 'styled-components';

const TierContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  padding: 30px 0;
`;

const TierCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  border: ${props => props.featured ? '2px solid #0062cc' : '1px solid #eee'};
  display: flex;
  flex-direction: column;
  position: relative;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const FeaturedBadge = styled.div`
  position: absolute;
  top: -12px;
  right: 20px;
  background: #0062cc;
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
`;

const TierName = styled.h3`
  font-size: 24px;
  color: #2b3d5c;
  margin: 0 0 10px 0;
`;

const Price = styled.div`
  font-size: 36px;
  font-weight: 700;
  color: #0062cc;
  margin: 20px 0;

  span {
    font-size: 16px;
    font-weight: 400;
    color: #666;
  }
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 30px 0;
  flex: 1;
`;

const Feature = styled.li`
  padding: 8px 0;
  color: #333;
  display: flex;
  align-items: center;
  gap: 10px;

  &:before {
    content: "✓";
    color: #0062cc;
    font-weight: bold;
  }
`;

const ActionButton = styled.button`
  width: 100%;
  padding: 15px;
  background: ${props => props.featured ? '#0062cc' : 'white'};
  color: ${props => props.featured ? 'white' : '#0062cc'};
  border: 1px solid #0062cc;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${props => props.featured ? '#0056b3' : '#f8f9fa'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const PropertyLimit = styled.div`
  background: #f8f9fa;
  padding: 10px;
  border-radius: 6px;
  text-align: center;
  margin: 20px 0;
  font-size: 14px;
  color: #666;
`;

const SubscriptionTiers = ({ 
  tiers, 
  currentTier, 
  onSelectTier, 
  loading 
}) => {
  return (
    <TierContainer>
      {tiers.map((tier, index) => (
        <TierCard 
          key={tier.id} 
          featured={index === 1}
        >
          {index === 1 && <FeaturedBadge>Most Popular</FeaturedBadge>}
          
          <TierName>{tier.name}</TierName>
          
          <Price>
            ${tier.monthly_price}
            <span>/month</span>
          </Price>

          <PropertyLimit>
            Up to {tier.property_limit} properties
          </PropertyLimit>

          <FeatureList>
            {tier.features && Object.entries(tier.features).map(([key, value]) => (
              <Feature key={key}>
                {key.split('_').map(word => 
                  word.charAt(0).toUpperCase() + word.slice(1)
                ).join(' ')}
              </Feature>
            ))}
          </FeatureList>

          <ActionButton
            featured={index === 1}
            onClick={() => onSelectTier(tier)}
            disabled={loading || (currentTier && currentTier.id === tier.id)}
          >
            {loading ? 'Processing...' : 
              currentTier && currentTier.id === tier.id ? 
              'Current Plan' : 'Select Plan'}
          </ActionButton>
        </TierCard>
      ))}
    </TierContainer>
  );
};

export default SubscriptionTiers;